<template>
  <div class="storageManeagePage">
    <div class="banner">
      <img src="../../assets/images/banner1.png" alt="" />
    </div>
    <div class="breadcrumb flex-rowc">
      <div class="breadcrumb_icon2">
        <i class="iconfont icon-touzijihuaguanli"></i>
      </div>
      <div class="breadcrumb_item">基础设置&客服帮助</div>
      <div class="breadcrumb_item_arrow"></div>
      <div class="breadcrumb_item">仓储资源管理</div>
    </div>

    <!-- 数据展示 -->
    <div class="data_show" v-if="isShow">
      <!-- 仓库货架列表 start -->
      <div class="state_two">
        <div class="card_info">
          <p>仓库名称：{{ shelfItem.whname }}</p>
          <p>所属企业：{{ shelfItem.qyname }}</p>
        </div>
        <div class="card_list" v-if="shelfData.length > 0">
          <div class="card_item" v-for="item in shelfData" :key="item.id">
            <p>货架名称：{{ item.whname }}</p>
            <div class="operation flex-rowr">
              <div class="btn" @click="handlEdit(item.id)">修改货架名称→</div>
              <div class="btn" @click="handleGo(item.id)">管理货架→</div>
            </div>
          </div>
        </div>
        <div class="noData" v-else>您还没有设置货架信息</div>
      </div>

      <div class="primary-button return" @click="handleReturn">
        <i class="iconfont icon-yuyinjiantou"></i> 返回
      </div>
      <div class="return-fixd">
        <div class="primary-button" @click="handleAddOne">+新增货架</div>
      </div>
      <!-- 仓库货架列表 end -->
    </div>

    <!-- 数据搜索 -->
    <div class="data_add" v-else>
      <div class="add_edit">
        <div class="tit">货架名称</div>
        <div class="input_box">
          <!-- <input type="text" placeholder="输入货架名称" v-model="name"> -->
          <van-field
            v-model="name"
            placeholder="输入货架名称"
            @focus="handleFocus"
            @blur="handleBlur"
          />
        </div>
        <div class="primary-button" @click="handleQuery">
          {{ isEdit ? "保存" : "确认" }}
        </div>
        <div class="primary-button return" @click="isShow = true">
          <i class="iconfont icon-yuyinjiantou"></i> 返回
        </div>
      </div>
    </div>

    <Tabbar v-if="isShowTabbar"></Tabbar>
  </div>
</template>

<script>
import {
  getMenuAuthTwo,
  getWearhouseDetail,
  addWearhouseShelf,
  editWearhouseShelf,
  encryptstringadd,
  encryptstringview,
} from "../../api/api";
import Tabbar from "../../components/Tabbar.vue";
import { mapState } from "vuex";
export default {
  name: "sManageTwo",
  components: {
    Tabbar,
  },
  data() {
    return {
      isShowTabbar: true,

      qyid: 0,

      parentid: "",
      state: 1,
      isEdit: false,
      editId: "",
      isShow: true,

      listData: [],
      shelfItem: "",
      shelfData: [],

      name: "", // 仓库名称
    };
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    this.getMenuAuthTwo();

    let { routerList, USERINFO, menuItem } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.id;
    } else {
      this.qyid = 0;
    }
    this.roleId = USERINFO.roleid;
    this.menuItem = menuItem;

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, this.OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.parentid = id;
        this.initData();
      } else {
        this.$router.back();
      }
    },

    // 获取菜单栏权限
    getMenuAuthTwo() {
      let menuItem = this.$store.state.menuItem;
      getMenuAuthTwo(menuItem.parentid).then((res) => {
        res
          .filter((item) => {
            return item.id == menuItem.id;
          })
          .map((item) => {
            // 操作权限
            if (item.dorange) {
              this.operationList = item.dorange.split(",");
            }
          });
      });
    },

    initData() {
      getWearhouseDetail({ id: this.parentid }).then((res) => {
        if (res.length > 0) {
          let dataNew = res[0];
          this.shelfItem = dataNew;
          this.shelfData = dataNew.childs2;
        }
      });
    },

    // 返回
    handleReturn() {
      history.back();
    },

    handleGo(id) {
      let { parentid } = this;
      // this.$router.push(`/storageIndex/sManageThree/${parentid}/${id}`);
      this.encryptstringadd('sManageThree',{parentid, id})
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 新增仓库
    handleAddOne() {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      this.name = "";
      this.isShow = false;
      this.isEdit = false;
    },
    // 编辑仓库名
    handlEdit(id) {
      let { roleId } = this;
      if (this.operationList.indexOf(roleId) == -1) {
        this.$toast("暂无权限");
        return;
      }
      let { shelfData } = this;
      let filter = shelfData.filter((v) => v.id == id);
      this.name = filter[0].whname;
      this.editId = id;
      this.isShow = false;
      this.isEdit = true;
    },

    // 确认
    handleQuery() {
      let { name, isEdit, parentid, editId, qyid } = this;
      if (name === "") {
        this.$toast("请输入货架名称");
        return;
      }
      if (!isEdit) {
        let params = {
          parentid: parentid,
          whname: name,
          isuse: true,
          qyid: qyid,
          openid: this.$store.state.OPENID,
        };
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        addWearhouseShelf(params).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.initData(parentid);
              this.$toast.success(res.message);
              this.isShow = true;
              Toast.clear();
            }, 1000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message || "提交失败，请稍后重试！");
            setTimeout(() => {
              this.isShow = true;
            }, 2000);
          }
        });
      } else {
        let params = {
          id: editId,
          parentid: parentid,
          whname: name,
          isuse: true,
          qyid: qyid,
          openid: this.$store.state.OPENID,
        };
        const Toast = this.$toast.loading({
          message: "提交中...",
          forbidClick: true,
        });
        editWearhouseShelf(params).then((res) => {
          if (res.result) {
            setTimeout(() => {
              this.initData(parentid);
              this.$toast.success(res.message);
              this.isShow = true;
              Toast.clear();
            }, 1000);
          } else {
            Toast.clear();
            this.$toast.fail(res.message || "提交失败，请稍后重试！");
            setTimeout(() => {
              this.isShow = true;
            }, 2000);
          }
        });
      }
    },

    // 获取焦点
    handleFocus() {
      this.isShowTabbar = false;
    },
    // 失去焦点
    handleBlur() {
      this.isShowTabbar = true;
    },
  },
};
</script>

<style lang="less" scoped>
.storageManeagePage {
  padding-bottom: 350px;
  .breadcrumb {
    padding-bottom: 65px;
  }
  .noData {
    font-size: 28px;
    color: #aaaaaa;
    margin: 100px auto 0;
    text-align: center;
  }
  .card_info {
    background: #f6f6f6;
    border-radius: 30px;
    padding: 50px;
    box-sizing: border-box;
    margin-bottom: 40px;
    p {
      font-size: 26px;
      color: #404d6c;
      margin-bottom: 15px;
      line-height: 30px;
    }
  }
  .data_add {
    .tit {
      font-size: 30px;
      color: #444444;
      text-align: center;
    }
    .input_box {
      margin: 38px auto 100px;
    }
  }
  .data_show {
    // min-height: 55vh;
    .state_two {
      padding: 0 75px 30px;
    }
  }
  .card_item {
    background: #f6f6f6;
    border-radius: 30px;
    padding: 50px 20px 20px 50px;
    box-sizing: border-box;
    margin-bottom: 50px;
    p {
      font-size: 26px;
      color: #404d6c;
      margin-bottom: 15px;
      line-height: 30px;
    }
    .operation {
      margin-top: 30px;
      .btn {
        font-size: 20px;
        color: #fff;
        height: 50px;
        line-height: 50px;
        background: #6e5c86;
        border-radius: 25px;
        padding: 0 30px;
        &:last-child {
          margin-left: 30px;
        }
      }
    }
  }
}
</style>